import {Navigate} from 'react-router-dom';

import {Module} from '@dms/api/shared';
import {moduleKeys} from '@dms/config';
import {featureFlags} from '@dms/feature-flags';
import {sourcingRoutes} from '@dms/routes';
import {permissions} from '@dms/shared';

import {SourcingListingPage} from './components/SourcingListingPage/SourcingListingPage';
import {VehicleDetailPage} from './pages/VehicleDetail/VehicleDetailPage';

export const SourcingModule: Module = {
  id: moduleKeys.sourcing,
  requiredPermission: [permissions.sourcingOffersRead, permissions.sourcingRead],
  layoutProps: {
    title: 'module.sourcing.title',
    icon: 'sidebar/sourcing',
  },
  routerProps: {
    path: sourcingRoutes.home,
    element: <Navigate to={sourcingRoutes.classifieds} replace />,
  },
  content: [
    // === Classifieds group ===
    {
      id: 'sourcing-classifieds-group',
      routerProps: {
        path: sourcingRoutes.classifieds,
      },
      layoutProps: {
        title: 'page.sourcing.labels.classifieds',
        icon: 'sidebar/sourcing',
      },
    },
    {
      id: 'sourcing-classifieds',
      parentId: 'sourcing-classifieds-group',
      routerProps: {
        path: sourcingRoutes.classifieds,
        element: <SourcingListingPage />,
      },
      layoutProps: {
        title: 'general.actions.allOffers',
        icon: 'sidebar/sourcing_all_offers',
      },
    },
    {
      id: 'sourcing-classifieds_userFavourite',
      parentId: 'sourcing-classifieds-group',
      routerProps: {
        path: sourcingRoutes.classifieds_userFavourite,
        element: <SourcingListingPage />,
      },
      layoutProps: {
        title: 'general.actions.favourites',
        icon: 'sidebar/sourcing_favourites',
      },
    },
    {
      id: 'sourcing-classifieds_userToBuy',
      parentId: 'sourcing-classifieds-group',
      routerProps: {
        path: sourcingRoutes.classifieds_userToBuy,
        element: <SourcingListingPage />,
      },
      layoutProps: {
        title: 'entity.vehicle.labels.toBuyPage',
        icon: 'sidebar/sourcing_to_buy',
      },
    },
    {
      id: 'sourcing-classifieds_comparison',
      parentId: 'sourcing-classifieds-group',
      routerProps: {
        path: sourcingRoutes.classifieds_comparison,
        element: <SourcingListingPage />,
      },
      layoutProps: {
        title: 'entity.vehicle.labels.comparisonPage',
        icon: 'sidebar/sourcing_comparison',
      },
    },
    {
      id: 'sourcing-classifieds_userHidden',
      parentId: 'sourcing-classifieds-group',
      routerProps: {
        path: sourcingRoutes.classifieds_userHidden,
        element: <SourcingListingPage />,
      },
      layoutProps: {
        title: 'entity.vehicle.labels.hiddenPage',
        icon: 'sidebar/sourcing_hidden',
      },
    },
    {
      id: 'sourcing-classifieds_userCarvagoBuy',
      parentId: 'sourcing-classifieds-group',
      requiredFeatureFlag: featureFlags.SOURCING_CARVAGO_BUY,
      routerProps: {
        path: sourcingRoutes.classifieds_userCarvagoBuy,
        element: <SourcingListingPage />,
      },
      layoutProps: {
        title: 'entity.vehicle.labels.carvagoBuyPage',
        icon: 'sidebar/sourcing_to_buy',
      },
    },
    // === Auctions group (feature-flagged) ===
    {
      id: 'sourcing-auctions-group',
      requiredFeatureFlag: featureFlags.SOURCING_AUCTIONS,
      routerProps: {
        path: sourcingRoutes.auctions,
      },
      layoutProps: {
        title: 'page.sourcing.labels.auctions',
        icon: 'sidebar/sourcing',
      },
    },
    {
      id: 'sourcing-auctions',
      parentId: 'sourcing-auctions-group',
      requiredFeatureFlag: featureFlags.SOURCING_AUCTIONS,
      routerProps: {
        path: sourcingRoutes.auctions,
        element: <SourcingListingPage />,
      },
      layoutProps: {
        title: 'general.actions.allOffers',
        icon: 'sidebar/sourcing_all_offers',
      },
    },
    {
      id: 'sourcing-auctions_userFavourite',
      parentId: 'sourcing-auctions-group',
      requiredFeatureFlag: featureFlags.SOURCING_AUCTIONS,
      routerProps: {
        path: sourcingRoutes.auctions_userFavourite,
        element: <SourcingListingPage />,
      },
      layoutProps: {
        title: 'general.actions.favourites',
        icon: 'sidebar/sourcing_favourites',
      },
    },
    {
      id: 'sourcing-auctions_userToBuy',
      parentId: 'sourcing-auctions-group',
      requiredFeatureFlag: featureFlags.SOURCING_AUCTIONS,
      routerProps: {
        path: sourcingRoutes.auctions_userToBuy,
        element: <SourcingListingPage />,
      },
      layoutProps: {
        title: 'entity.vehicle.labels.toBuyPage',
        icon: 'sidebar/sourcing_to_buy',
      },
    },
    {
      id: 'sourcing-auctions_comparison',
      parentId: 'sourcing-auctions-group',
      requiredFeatureFlag: featureFlags.SOURCING_AUCTIONS,
      routerProps: {
        path: sourcingRoutes.auctions_comparison,
        element: <SourcingListingPage />,
      },
      layoutProps: {
        title: 'entity.vehicle.labels.comparisonPage',
        icon: 'sidebar/sourcing_comparison',
      },
    },
    {
      id: 'sourcing-auctions_userHidden',
      parentId: 'sourcing-auctions-group',
      requiredFeatureFlag: featureFlags.SOURCING_AUCTIONS,
      routerProps: {
        path: sourcingRoutes.auctions_userHidden,
        element: <SourcingListingPage />,
      },
      layoutProps: {
        title: 'entity.vehicle.labels.hiddenPage',
        icon: 'sidebar/sourcing_hidden',
      },
    },
    // === Detail pages (no sidebar appearance) ===
    {
      id: 'sourcing-vehicleDetail',
      routerProps: {
        path: sourcingRoutes.vehicleDetail,
        element: <VehicleDetailPage />,
      },
    },
    {
      id: 'sourcing-auctionDetail',
      routerProps: {
        path: sourcingRoutes.auctionDetail,
        element: <VehicleDetailPage />,
      },
    },
  ],
};
